import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { self as getFirstLastNameTitle } from '@medflex/utils/getFullNameWithTitle';
import formatDateOfBirth from '@medflex/utils/getDateOfBirthFormatted';
import Button from '../Button';

const ContactInfoRepresentatives = ({ mainContact, subContacts, onOpenContactChat }) => {
  const { t } = useTranslation('components', { keyPrefix: 'ContactInfo.representatives' });

  const handleOpenContactChat = contactId => () => onOpenContactChat(contactId);

  if (mainContact) {
    return (
      <>
        <div className="mb-2">{t('mainContactTitle')}</div>
        <Button kind="link" onClick={handleOpenContactChat(mainContact.id)}>
          {getFirstLastNameTitle(mainContact)}, {formatDateOfBirth(mainContact.dateOfBirth)}
        </Button>
      </>
    );
  }

  if (subContacts?.length) {
    return (
      <>
        <div className="mb-2">{t('subContactsTitle')}</div>
        {subContacts.map(c => (
          <Button key={c.id} kind="link" onClick={handleOpenContactChat(c.id)}>
            {getFirstLastNameTitle(c)}, {formatDateOfBirth(c.dateOfBirth)}
          </Button>
        ))}
      </>
    );
  }

  return null;
};

ContactInfoRepresentatives.defaultProps = {
  mainContact: null,
  subContacts: null,
  onOpenContactChat: () => {},
};

ContactInfoRepresentatives.propTypes = {
  onOpenContactChat: PropTypes.func,
  mainContact: PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.string.isRequired,
  }),
  subContacts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      dateOfBirth: PropTypes.string.isRequired,
    }),
  ),
};

export default ContactInfoRepresentatives;
